<template>
  <CanvasJSChart 
    v-if="hasData"
    :options="options" 
    :styles="styleOptions" 
  />
  <div v-else class="no-data-message">
    Loading chart data...
  </div>
</template>

<script>
export default {
  props: {
    seriesData: {
      type: Array,
      required: true,
      default: () => []
    },
    categories: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    hasData() {
      return this.seriesData && this.seriesData.length > 0 && 
             this.categories && this.categories.length > 0;
    },
    
    options() {
      return {
        animationEnabled: true,
        title: {
          text: ""
        },
        axisY: {
          prefix: "",
          tickLength: 0,
          includeZero: true
        },
        axisX: {
          interval: 1,
          labelAngle: -45,
          labelFontSize: 12
        },
        legend: {
          cursor: "pointer",
          itemclick: this.toggleDataSeries
        },
        toolTip: {
          shared: true
        },
        data: this.chartData
      };
    },
    
    chartData() {
      if (!this.hasData) return [];
      
      const colors = ["#e6453e", "#c6783d", "#3489e0", "#ebb02a", "#28a745", "#6f42c1"];
      
      return this.seriesData.map((series, index) => ({
        type: "stackedColumn",
        name: series.name || `Series ${index + 1}`,
        showInLegend: true,
        color: colors[index % colors.length],
        yValueFormatString: "##,###",
        dataPoints: series.data.map((value, categoryIndex) => ({
          label: this.categories[categoryIndex] || `Category ${categoryIndex + 1}`,
          y: value
        }))
      }));
    }
  },
  
  data() {
    return {
      styleOptions: {
        width: "100%",
        height: "360px"
      }
    };
  },
  
  methods: {
    toggleDataSeries(e) {
      if (typeof e.dataSeries.visible === "undefined" || e.dataSeries.visible) {
        e.dataSeries.visible = false;
      } else {
        e.dataSeries.visible = true;
      }
      e.chart.render();
    }
  }
};
</script>

<style scoped>
.no-data-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 360px;
  color: #666;
  font-style: italic;
}
.canvasjs-chart-credit {
  display: none !important;
}

</style>